<template>
	<v-row justify="center" v-show="opened">
		<v-dialog v-model="opened" width="500" persistent>
			<v-card class="general-dialog-card">
				<div class="general-dialog-scroll">
					<ErrorInfo :error="error" :showMessage="isAdmin || !isProdEnv" :icon="icon" />
				</div>
				<v-card-actions class="d-flex justify-center pb-8 pt-5">
					<v-btn depressed rounded color="primary" @click="closeDialog" class="px-4">
						{{ $t("common.close") }}
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</v-row>
</template>
<script lang="ts">
import Vue from "vue";
import { GeneralDialogMode } from "@/api/constants/enums";
import { Error } from "@/api/models/error.model";
import ErrorInfo from "@/components/common/ErrorInfo.vue";

export default Vue.extend({
	name: "GeneralDialog",
	components: {
		ErrorInfo
	},
	data: () => ({
		GeneralDialogMode,
		error: {} as Error
	}),
	updated() {
		if (this.status === 401) {
			this.$store.commit("desactivateDialog");
		}
	},
	created() {
		this.updatePayload();
	},
	watch: {
		uuid() {
			this.updatePayload();
		}
	},
	computed: {
		opened() {
			return this.$store.state.components.generalDialog.opened;
		},
		source() {
			return this.$store.state.components.generalDialog.source;
		},
		title() {
			return this.$store.state.components.generalDialog.title;
		},
		i18n() {
			return this.$store.state.components.generalDialog.i18n;
		},
		uuid(): string {
			return this.$store.state.components.generalDialog.uuid;
		},
		parameters() {
			return this.$store.state.components.generalDialog.parameters;
		},
		message() {
			return this.$store.state.components.generalDialog.message;
		},
		messages() {
			return this.$store.state.components.generalDialog.messages;
		},
		mode() {
			return this.$store.state.components.generalDialog.mode;
		},
		icon() {
			if (this.mode === GeneralDialogMode.SUCCESS) {
				return "mdi-checkbox-marked-circle-outline";
			}

			if (this.mode === GeneralDialogMode.FORM_ERROR) {
				return "mdi-file-document-alert-outline";
			}

			return "mdi-alert-circle-outline";
		},
		isAdmin() {
			return this.$store.state.user.role === "admin";
		},
		isProdEnv() {
			return process.env.NODE_ENV === "production";
		},
		status() {
			return this.$store.state.components.generalDialog.status;
		}
	},
	methods: {
		closeDialog() {
			if (this.status === 409) {
				this.$emit("close");
			}
			this.$store.commit("desactivateDialog");
		},
		updatePayload() {
			this.error = {
				title: this.title,
				i18n: this.i18n,
				message: this.message,
				messages: this.messages,
				source: this.source,
				status: this.status,
				parameters: this.parameters
			};
		}
	}
});
</script>

<style lang="scss" scoped>
.no-style {
	list-style-type: none;
}
.container {
	width: 95%;
	padding: 2rem;
	h4 {
		width: 95%;
	}
}

.general-dialog-card {
	padding-top: 3.6em;
}
</style>
